import angular from 'angular';
import modalMap from '../shared/components/modal-map/modal-map.view.html';
import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';
let inject = [
  '$scope',
  'SalesHomeService',
  '$state',
  '$rootScope',
  'SharedService',
  '$uibModal',
  '$timeout',
  'Pagination',
  'SessionService',
  '$window'
];

class SalesHomeController{
  constructor ($scope, SalesHomeService, $state, $rootScope, SharedService, $uibModal, $timeout, Pagination, SessionService, $window) {
    this.$state = $state;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.SalesHomeService = SalesHomeService;
    this.Pagination = Pagination;
    this.SharedService = SharedService;
    this.SessionService =SessionService;
    this.$window = $window;
    this.dashboard = {};
    this.dashboard.state = {};
    this.documentQuantitiesChart = {};
    this.lastItemsBought = {};
  
    this.dashboard.updatedAt = '';
    this.showDateRange = false;
  
    this.dashboard.ordersTotalValue = 0;
    this.dashboard.quotesTotalValue = 0;
    this.dashboard.billsTotalValue = 0;
  
    this.dashboard.billfoldResume = {
      cupo_credito: 0,
      total_cartera: 0,
      cupo_disponible: 0,
      cartera_vencida: 0
    };
  
    this.dashboardFormData = {
      startDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD')
    };
  
    this.orderResumeChart = {
      data: {
        "type":"ring",
        "legend":{
          //   "highlight-plot":true,
          "x":"80%",
          "y":"0%"
        },
        "plotarea":{
          // "margin-right":"20%"
        },
        "plot":{
          "highlight-state":{
            "background-color":"red #ffe6e6",
            "border-width":1,
            "border-color":"red",
            "line-style":"dotted"
          },
          "slice":"50%",
          "value-box":{
            "placement":"out",
            "font-color":"black",
            "font-size":11,
            "font-weight":"normal"
          },
          "animation":{
            "effect":"2",
            "speed":"300",
            "method":"0",
            "sequence":"1"
          }
        },
        "series":[
          {"values":[234], "text": "Enero"},
          {"values":[121], "text": "Febrero"},
          {"values":[77],  "text": "Marzo"}
        ]
      }
    }
  }

  $onInit(){
    let dash = $('#dashboardForm #dashboardStartDate, #dashboardForm #dashboardEndDate');
    dash.on('changeDate', function(ev){
      $(this).datepicker('hide');
    });
  
    /* Hide date picker on date selected */
    dash.datepicker().on('changeDate', function (e) {
      if(e.viewMode === 'days') { $(this).blur(); }
    });
  
    /* Run search by default */
    this.$timeout(() => {
      $('#btnFilterDashboard').click()
    }, 1000);
  }
  
  getDashboardInfo(form) {
    this.dashboard.ordersTotalValue = 0;
    this.dashboard.quotesTotalValue = 0;
    this.dashboard.billsTotalValue = 0;
    
    this.dashboard.billfoldResume = {
      cupo_credito: 0,
      total_cartera: 0,
      cupo_disponible: 0,
      cartera_vencida: 0
    };
    
    let startDate = this.dashboardFormData.startDate;
    let endDate   = this.dashboardFormData.endDate;
    let selectDate = +this.dashboardFormData.selectDate;
    
    if((!this.showDateRange && !selectDate) ||
      (this.showDateRange && (!startDate || !endDate || (startDate > endDate) ))
    ) {
      angular.forEach(form.$error.required, function(field) { field.$setDirty(); });
    }
    else {
      if(!this.showDateRange) {
        // Current month
        if(selectDate === 999) {
          startDate = moment().startOf('month').format('YYYY-MM-DD');
        }
        else {
          startDate = moment().subtract(selectDate, 'months').format('YYYY-MM-DD');
        }
        
        endDate = moment().format('YYYY-MM-DD');
      }
      
      this.dashboard.state = {};
      this.dashboard.state.loading = true;
      
      this.getOrdersConsolidated(startDate, endDate);
      this.getInfoBillfoldState();
      this.getLastItemsBought();
    }
  }
  
  createDocumentsChart(startDate, endDate, labels, orderValues, quoteValues, billValues) {
    this.documentQuantitiesChart = {
      data: {
        type : 'line',
        "title":{
          "text":"Trazabilidad Comercial - "  + this.shCtrl.globals.currentClient.third.name
        },
        "subtitle":{
          "text":"Comportamiento del Cliente " +
          this.shCtrl.globals.currentClient.operatingCenter.name +
          " desde " + startDate + "  hasta " + endDate,
          "font-weight":"normal"
        },
        "legend": {
          "x": "4%",
          "y": "15%",
          "layout": "horizontal",
          "tooltip": {
            "width": "20%",
            "height": "20%",
            "wrap-text": true,
            "padding": "5%",
            "background-color": "white",
            "font-color": "black",
            "font-family": "Georgia",
            "sticky": true,
            "timeout": 10000
          }
        },
        "zoom":{
          "background-color":"#ccccff",
          "border-width":5,
          "border-color":"#3399ff",
          "alpha":0.3,
          "label":{ //Zooming Labels
            "visible":true,
            "font-color":"#3399ff",
            "font-family":"Georgia",
            "font-size":10,
            "font-style":"normal", //"italic" or "normal"
            "font-weight":"normal", //"bold" or "normal"
            "background-color":"white",
            "border-width":1,
            "border-color":"#3399ff",
            "alpha":0.7,
            "padding":"5%"
          }
        },
        "preview":{
          "type":"area",  //"area" (default) or "line"
          "line-color":"#33ccff",
          "line-width":2,
          "line-style":"dotted",
          "background-color":"#ffffff",
          "alpha":1,
          "alpha-area":0.1
        },
        "plotarea": {
          "margin-top": "25%"
        },
        "plot": {
          // "short": true,
          "animation":{
            "effect":"2",
            "speed":"300",
            "method":"0",
            "sequence":"1"
          },
          // "value-box": {
          //   "text": "$ %v",
          //   "thousands-separator":",",
          //   // "short":true,
          //   // "short-unit":"M",
          //   "font-color": "#666699",
          //   "font-family": "Georgia",
          //   "font-size": 10,
          //   "font-weight": "normal",
          //   "font-style": "normal",
          //   "rules": [
          //     {
          //       "rule": "%v >= 0",
          //     },
          //     {
          //       "rule": "%v <= 0",
          //       "font-color": "black",
          //       "font-size": 0,
          //     }
          //   ]
          // }
        },
        "scale-x": {
          "labels": labels,
          "zooming":true
        },
        "scale-y": {
          "short":true,
          "short-unit":"M",
          "font-size":"9px",
          "guide":{
            "line-style":"dotted"
          },
        },
        "crosshair-x": {
          "plot-label": {
            "text": "$ %v en %t",
            "thousands-separator":","
          },
          "scale-label": {
            "text": "%t",
          }
        },
        series : [
          // {
          //   values : quoteValues,
          //   "text": "Cotizaciones - Total $ " + $filter('currency')(this.dashboard.quotesTotalValue, '', 0),
          //   "description": "en Cotizaciones",
          //   "line-color": "#f39c12",
          //   "line-style": "solid",
          //   "marker": {
          //     "background-color": "#f39c12",
          //     "size": 5
          //   }
          // },
          {
            values : orderValues,
            "text": "Pedidos - Total $ " + $filter('currency')(this.dashboard.ordersTotalValue, '', 0),
            "description": "en Pedidos",
            "line-color": "#008000",
            "line-style": "solid",
            "marker": {
              "background-color": "#008000",
              "size": 5
            }
          },
          // {
          //   values : billValues,
          //   "text": "Facturas - Total $ " + $filter('currency')(this.dashboard.billsTotalValue, '', 0),
          //   "description": "en Facturas",
          //   "line-color": "#356296",
          //   "line-style": "solid",
          //   "marker": {
          //     "background-color": "#356296",
          //     "size": 5
          //   }
          // }
        ]
      }
    };
  }
  
  getOrdersConsolidated(startDate, endDate) {
    let thirdId = this.shCtrl.globals.currentClient.third.id;
    let branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
    let contactoId = this.shCtrl.globals.currentClient.contact.id;
    
    this.SalesHomeService.getOrdersConsolidated(
      thirdId,
      startDate,
      endDate,
      branchCode,
      contactoId
    )
      .then((orders) => {
        this.dashboard.orders = orders;
        
        // Orders
        angular.forEach(orders.pedidos, (ordersQuantity, key) => {
          if(!ordersQuantity) { orders.pedidos[key] = 0; }
          if(ordersQuantity > 0) { this.dashboard.ordersTotalValue += orders.pedidos[key]; }
        });
        
        // Quotes
        // angular.forEach(orders.cotizaciones, function(quotesQuantity, key) {
        //   if(!quotesQuantity) { orders.cotizaciones[key] = 0; }
        //   if(quotesQuantity > 0) { this.dashboard.quotesTotalValue += orders.cotizaciones[key]; }
        // });
        //
        // // Bills
        // angular.forEach(orders.facturas, function(billsQuantity, key) {
        //   if(!billsQuantity) { orders.facturas[key] = 0; }
        //   if(billsQuantity > 0) { this.dashboard.billsTotalValue += orders.facturas[key]; }
        // });
        
        this.createDocumentsChart(startDate, endDate, orders.fechas, orders.pedidos, orders.cotizaciones, orders.facturas);
        
        this.dashboard.state.loading = false;
        this.dashboard.state.loaded = false;
        
        this.dashboard.updatedAt = $filter('date')(new Date(),'yyyy-MM-dd HH:mm:ss');
      })
      .catch(function(error) {});
  }
  
  getLastItemsBought() {
    this.dashboard.state.loadingLastItemsBought = true;
    this.dashboard.state.loadedLastItemsBought = false;
    let userId = '';
    try{ userId = this.shCtrl.globals.currentUser.userId; }
    catch(e){}
    
    this.$timeout(() => {
      this.SalesHomeService.getLastItemsBought(userId)
        .then((response) => {
          this.lastItemsBought = response;
          this.dashboard.state.loadingLastItemsBought = false;
          this.dashboard.state.loadedLastItemsBought = true;
        })
        .catch((error) => {
          this.dashboard.state.loadingLastItemsBought = false;
          this.dashboard.state.loadedLastItemsBought = true;
        });
    }, 2000);
  }
  
  getInfoBillfoldState() {
    this.dashboard.state.loadingBillfoldResume = true;
    this.dashboard.state.loadedBillfoldResume = true;
    
    let thirdDocumentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
    let branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
    
    this.SalesHomeService.getInfoBillfoldState(
      thirdDocumentNumber,
      branchCode
    )
      .then((billfoldResume) => {
        this.dashboard.billfoldResume = billfoldResume;
        
        this.dashboard.state.loadingBillfoldResume = false;
        this.dashboard.state.loadedBillfoldResume = true;
      })
      .catch((error) => {
        this.dashboard.state.loadingBillfoldResume = false;
        this.dashboard.state.loadedBillfoldResume = true;
      });
  }
  
  openMap(branch){
    let options = {
      center : {
        latitude  : branch.latitude,
        longitude : branch.longitude
      },
      zoom: 15,
      pan : true
    };
    let modal_options = this.$uibModal.open({
      animation: true,
      template: modalMap,
      controller : 'ModalMapController',
      controllerAs : 'mdCtrl',
      size: '',
      resolve : {
        modalOptions : () => options
      }
    });
    modal_options.result.then(() => {
    
    }).catch(reason => {
    
    });
  }

  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }
}

SalesHomeController.$inject = inject;

export default SalesHomeController;




// WEBPACK FOOTER //
// ./www/components/sales-home/sales-home.controller.js